import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import outerPhoto from "../../icons/photos/loginPagePhoto.png";
import "./auth.scss";
import {
    emailValidation,
    noSpaceOnChange,
    phoneValidation,
} from "../../validations/validation";

import { forgotPassword } from "../../service/api/user/forgotPassword";
import InputField from "../../jsx/components/fields/inputField";
import { validateSecurityCode } from "../../service/api/user/validateSecurityCode";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { activateUser } from "../../service/api/user/activationCode";
import { resendCode } from "../../service/api/user/resendActivationCode";
import VerifyComponent from "./verifyComponent";

export default function VerifyEmailPhone(props) {


    return (
        <div className="">
            <div className="row  align-items-center justify-contain-center bg-login">
                <div className="col-xl-12" style={{ height: "100vh" }}>
                    <div className="card border-0">
                        <div className="card-body login-bx" style={{ height: "100vh" }}>
                            <div className="row ">
                                <div className="col-xl-7 col-md-6  text-center">
                                    <img src={outerPhoto} alt="" style={{ maxWidth: "100%" }} />
                                </div>
                                <div
                                    className="col-xl-4 col-md-6 pe-0 d-flex"
                                    style={{ alignItems: "center" }}>
                                    <VerifyComponent />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}
